// Create a new file: /components/workflow/StructuralConditionalNode.jsx

import React from 'react';
import { Handle } from 'reactflow';
import { Network } from 'lucide-react'; // Diamond-like icon

const statusStyles = {
  idle: 'border-zinc-500',
  pending: 'border-yellow-400',
  queued: 'border-blue-400',
  failed: 'border-red-500',
  success: 'border-green-500',
  running: 'animate-[pulse_1s_infinite] border-green-500',
  approvalNeeded: 'animate-[glow_1.5s_infinite] border-orange-500',
  diagnosing: 'animate-[pulse_1s_infinite] border-purple-500', // 👈 new line
};

const StructuralConditionalNode = ({ id, data }) => {
  const status = data?.status || 'idle';
  const selectedFieldName =
    data.selectedConditionPath?.split('.').pop() || 'Not Configured';

  return (
    <div className="relative flex h-48 w-48 items-center justify-center">
      {/* Diamond shape wrapper */}
      <div
        className={`relative h-40 w-40 rotate-45 transform border bg-zinc-800 text-zinc-100 shadow-md ${statusStyles[status]}`}
      >
        {/* Content inside diamond, rotated back */}
        <div className="flex h-full -rotate-45 transform flex-col items-center justify-center p-2 text-center">
          <Network className="mb-1 text-purple-400" size={24} />
          <h3 className="text-base font-bold text-white">Condition</h3> {id}
          <p
            className="w-full truncate text-xs text-slate-300"
            title={selectedFieldName}
          >
            On: {selectedFieldName}
          </p>
        </div>
      </div>

      {/* Input handle */}
      <Handle
        type="target"
        position="left"
        className="!bg-yellow-400"
        style={{ left: '-5px', top: '50%' }}
      />
      {/* 'true' output handle */}
      <Handle
        type="source"
        position="right"
        id="true"
        className="!bg-green-400"
        style={{ right: '-5px', top: '50%' }}
      />
      {/* 'false' output handle */}
      <Handle
        type="source"
        position="bottom"
        id="false"
        className="!bg-red-500"
        style={{ bottom: '-5px', left: '50%' }}
      />
    </div>
  );
};

export default StructuralConditionalNode;
